import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=3a79a8bf&scoped=true&"
import script from "./Curriculum.vue?vue&type=script&lang=js&"
export * from "./Curriculum.vue?vue&type=script&lang=js&"
import style0 from "./Curriculum.vue?vue&type=style&index=0&id=3a79a8bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a79a8bf",
  null
  
)

export default component.exports